import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Login from '../views/Login.vue'
import Welcome from '@/views/welcome.vue'
import Users from '@/components/Users.vue'
import Rote from '@/components/Rote.vue'
import Product from '@/components/Product.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Login
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView,
    redirect: '/home/welcome',
    children: [
      { path: '/home/welcome', component: Welcome },
      { path: '/home/users', component: Users },
      { path: '/home/rote', component: Rote },
      { path: '/home/product', component: Product }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫:若没有登录则跳转到登录页面
router.beforeEach((to, from, next) => {
  if (to.path === '/login') return next()// 若访问登录页面则直接进入
  const token = window.sessionStorage.getItem('token')
  if (!token) return next('/login')// 若没有登录则跳转到登录页面
  next()
})

export default router
